export default {"src":"/_next/static/media/icon_bar-solid.94af23fe.svg","height":512,"width":448};